var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60545 11.3946C6.26354 11.0533 6.26354 10.4984 6.60545 10.1571C6.94736 9.81518 7.50107 9.81518 7.84298 10.1571C8.61666 10.9308 9.9668 10.9314 10.7405 10.1571L13.6514 7.24615C14.4502 6.44738 14.4502 5.1474 13.6514 4.34863C12.8526 3.54985 11.5527 3.54985 10.7539 4.34863C10.412 4.69054 9.85828 4.69054 9.51637 4.34863C9.17446 4.00729 9.17446 3.45241 9.51637 3.11108C10.9972 1.62964 13.4081 1.62964 14.8889 3.11108C16.3704 4.59252 16.3704 7.00226 14.8889 8.4837L11.978 11.3946C11.237 12.1357 10.2644 12.5056 9.29173 12.5056C8.31909 12.5056 7.34587 12.1351 6.60545 11.3946ZM5.79793 16C6.77057 16 7.74321 15.6295 8.48422 14.8891C8.82613 14.5477 8.82613 13.9929 8.48422 13.6515C8.1423 13.3096 7.58859 13.3096 7.24668 13.6515C6.44733 14.4509 5.14737 14.4503 4.34918 13.6515C3.55042 12.8527 3.55042 11.5528 4.34918 10.754L7.24376 7.85938C8.04311 7.06002 9.34308 7.06002 10.1413 7.85938C10.4832 8.2013 11.0369 8.2013 11.3788 7.85938C11.7207 7.51805 11.7207 6.96317 11.3788 6.62184C9.89737 5.1404 7.48765 5.1404 6.00623 6.62184L3.11107 9.51645C1.62964 10.9979 1.62964 13.4076 3.11107 14.8891C3.85207 15.6301 4.82529 16 5.79793 16Z",
    fill: "#258CFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.582673e07e6643e6b66aee963b6a90bd.svg";
export { ForwardRef as ReactComponent };